/* eslint semi: 1 */
import _ from 'lodash';
const NEW_PLAYER = 'NEW PLAYER';

export const NewPlayer = NEW_PLAYER;

export const FilterInvoiceSummary = (invoiceSummary, isPlanUpgrade) => {
  if (_.isEmpty(invoiceSummary)) {
    return null;
  }

  const { currency } = invoiceSummary;
  const subTotal = invoiceSummary.subtotal / 100;
  const vat = invoiceSummary.vat / 100;
  const vatInPercent = invoiceSummary.vatPercent
    ? 100 * invoiceSummary.vatPercent
    : Math.round((100 * (vat) / (subTotal)) * 10) / 10;
  const amount = invoiceSummary.amount / 100;

  // get current plan data
  const invoices = isPlanUpgrade ? invoiceSummary.items : invoiceSummary.items.filter(plan => plan.serial !== NEW_PLAYER);

  // get invoice amount by plan
  const invoicesGroupByPlan = {};
  for (const item of invoices) {
    item.value = Number(item.value) / 100;

    if (invoicesGroupByPlan[item.plan]) {
      invoicesGroupByPlan[item.plan] = invoicesGroupByPlan[item.plan] + item.value;
    } else {
      invoicesGroupByPlan[item.plan] = item.value;
    }
  }

  // Add all plan amounts altogether
  const currentPlanSubTotal = _.values(invoicesGroupByPlan).reduce((total, value) => total + parseInt(value), 0);

  // If there's vat, factor it in the total
  const currentPlanTotal = vatInPercent
    ? currentPlanSubTotal + (currentPlanSubTotal * (vatInPercent / 100))
    : currentPlanSubTotal;

  const currentPlanVat = vatInPercent
    ? currentPlanSubTotal * (vatInPercent / 100)
    : 0;

  return {
    subTotal: `${currency} ${subTotal.toFixed(2)}`,
    vatInPercent: `${vatInPercent}%`,
    vat: `${currency} ${vat.toFixed(2)}`,
    total: `${currency} ${amount.toFixed(2)}`,
    newPlayerCount: invoiceSummary.items.length,
    currentPlanSummary: {
      playerCount: invoices.length,
      subTotal: `${currency} ${currentPlanSubTotal.toFixed(2)}`,
      vat: `${currency} ${currentPlanVat.toFixed(2)}`,
      total: `${currency} ${currentPlanTotal.toFixed(2)}`
    }
  };
};
